module.exports = __webpack_public_path__ + "posture/static/img/pelvis_lean_right.7a23236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/pelvis_lean_right.png
// module id = nst3
// module chunks = 1